/**
 * The two marks every line of small print is joined with, and the call that
 * joins a line's parts (row T3228). Written once so the web and the phone draw
 * the same separator and a literal never sits in a template.
 */

/** The middle dot that separates the facts on one line. */
export const POINT = '·';

/** The percent sign a whole-number score is drawn with (T675). */
export const PERCENT = '%';

/** The em dash a missing value is drawn as. */
export const DASH = '—';

/** A detail line assembled from parts, a missing or empty part left out; a call rather than a template literal, so the JSX carries no literal. */
export function line(...parts: readonly (string | number | null | undefined | false)[]): string {
  return parts.filter((part): part is string | number => part !== null && part !== undefined && part !== false && part !== '').join(' ');
}
